import { ApiClient } from 'gain-web/shared-services/api-client.generated.service';

export class UserContext {
  public readonly data: ApiClient.IGainUserContextDto;

  constructor(data: ApiClient.IGainUserContextDto) {
    this.data = data;
  }
}
